"use strict";
/****
 * 新闻搜索组件
 *
 *  */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var webconfig = require('../../../config/web.js');
//require("../../../less/shared/so_newsbox.less");
var utils_1 = __importDefault(require("../commonutil/utils"));
function so_newsbox(opt) {
    var defaultOption = {
        dom: '.searchnews_box',
        key: '停复牌',
        header: '停复牌信息',
        infolist_eventcode: 'sjpd_tfpxx_tfpxxjd_wzqydjzh',
        more_eventcode: 'sjpd_tfpxx_tfpxxjd_djgd'
    };
    var option = $.extend({}, defaultOption, opt);
    var encodedkey = encodeURIComponent(option.key);
    var moreUrl = "//so.eastmoney.com/news/s?keyword=" + encodedkey + "&pageindex=1&searchrange=16384&sortfiled=4";
    $.ajax({
        url: webconfig.getWebPath('url') + "/dataapi/search/article",
        type: 'get',
        data: {
            keyword: option.key,
            page: 1,
            pagesize: 10,
            keywordPhase: true,
            excludeChannels: [1]
        },
        dataType: 'json',
        success: function (ret) {
            var _a;
            try {
                if (!ret.code) {
                    var list = (_a = ret.result) === null || _a === void 0 ? void 0 : _a.cmsArticleWeb;
                    var titlebox = $('<div class="titlebox"><b class="el icon icon_dot_b"></b><div class="tit">' + option.header + '解读</div><div class="more"><a target="_blank" href="' + moreUrl + '" tracker-eventcode="' + option.more_eventcode + '">更多&gt;&gt;</a></div>');
                    var contentbox = $('<div class="contentbox"></div>');
                    var listbox = $('<ul class="infolist"></ul>');
                    var box = $(option.dom);
                    box.addClass("searchnews_box");
                    box.append(titlebox);
                    box.append(contentbox);
                    contentbox.append(listbox);
                    for (var i = 0; i < (list === null || list === void 0 ? void 0 : list.length); i++) {
                        var item = list[i];
                        var dom = $('<li><a class="ll" target="_blank"></a><span class="lr"></span></li>');
                        $("span", dom).text(item.date.substring(5, 10));
                        $("a", dom).html(utils_1["default"].txtLeft("*" + item.title, 100, true)).attr("href", item.url).attr("tracker-eventcode", option.infolist_eventcode);
                        listbox.append(dom);
                        if (i == 4) {
                            listbox.append("<div class='splitline'></div>");
                        }
                    }
                }
            }
            catch (err) {
            }
        },
        error: function () {
        }
    });
}
exports["default"] = so_newsbox;
